import IconAsMaskImage from "../IconAsMaskImage";

function ImageUpload({ pureSvg, className, color }) {
  const svg = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.88059 8.59907C8.77305 8.59907 9.49653 7.87559 9.49653 6.98313C9.49653 6.09067 8.77305 5.36719 7.88059 5.36719C6.98813 5.36719 6.26465 6.09067 6.26465 6.98313C6.26465 7.87559 6.98813 8.59907 7.88059 8.59907Z"
        stroke="#667085"
        strokeWidth="1.21196"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1123 2.13477H7.88041C3.84055 2.13477 2.22461 3.75071 2.22461 7.79056V12.6384C2.22461 16.6782 3.84055 18.2942 7.88041 18.2942H12.7282C16.7681 18.2942 18.384 16.6782 18.384 12.6384V8.59853"
        stroke="#667085"
        strokeWidth="1.21196"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1523 6.98259V2.13477L16.7683 3.75071"
        stroke="#667085"
        strokeWidth="1.21196"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1521 2.13477L13.5361 3.75071"
        stroke="#667085"
        strokeWidth="1.21196"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.76562 15.8303L6.74892 13.1559C7.38722 12.7277 8.30831 12.7762 8.88197 13.269L9.1486 13.5034C9.77881 14.0447 10.7969 14.0447 11.4271 13.5034L14.7882 10.6189C15.4185 10.0776 16.4365 10.0776 17.0667 10.6189L18.3837 11.7501"
        stroke="#667085"
        strokeWidth="1.21196"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
}

export default ImageUpload;
